import { CSSProperties, HTMLAttributes, ReactNode } from 'react';

export interface HProps extends HTMLAttributes<HTMLHeadingElement> {
  size?: 'xl' | 'l' | 'm' | 's';
  className?: string;
  caption?: ReactNode;
  children?: ReactNode;
}

export function H1({ size = 'l', className = '', caption, children, ...props }: HProps) {
  return (
    <h1 className={`govuk-heading-${size} ${className}`} {...props}>
      {!!caption && <span className="govuk-caption-l">{caption}</span>}
      {children}
    </h1>
  );
}

export function H2({ size = 'm', className = '', caption, children, ...props }: HProps) {
  return (
    <h2 className={`govuk-heading-${size} ${className}`} {...props}>
      {!!caption && <span className="govuk-caption-l">{caption}</span>}
      {children}
    </h2>
  );
}

export function H3({ size = 's', className = '', caption, children, ...props }: HProps) {
  return (
    <h3 className={`govuk-heading-${size} ${className}`} {...props}>
      {!!caption && <span className="govuk-caption-l">{caption}</span>}
      {children}
    </h3>
  );
}

export interface LabelProps {
  id?: string;
  className?: string;
  htmlFor?: string;
  children?: ReactNode;
  size?: 'l' | 'm' | 's';
}
export function Label({ className = '', children, size, ...props }: LabelProps) {
  return (
    <label className={`govuk-label${size ? ' govuk-label--' + size : ''} ${className}`} {...props}>
      {children}
    </label>
  );
}

export interface HintProps {
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}
export function Hint({ className = '', children, ...props }: HintProps) {
  return (
    <div className={`govuk-hint ${className}`} {...props}>
      {children}
    </div>
  );
}

export interface BodyProps extends HTMLAttributes<HTMLParagraphElement> {
  size?: 'l' | 's';
  className?: string;
  children?: ReactNode;
}

export function Body({ size, className = '', children, ...props }: BodyProps) {
  let bodyClass = 'govuk-body';
  if (size) bodyClass += '-' + size;
  return (
    <p {...props} className={`${bodyClass} ${className}`}>
      {children}
    </p>
  );
}

export interface HRProps {
  size?: 'xl' | 'l' | 'm';
  className?: string;
}

export function HR({ size, className = '' }: HRProps) {
  let bodyClass = 'govuk-section-break govuk-section-break--visible';
  if (size) bodyClass += ' govuk-section-break govuk-section-break--' + size;
  return <hr className={`${bodyClass} ${className}`} />;
}
